import React from "react";
import ct from "class-types.macro";
import { RelatedSearchTermsResults } from "./SearchPageResult";
interface Props {
  relatedSearchTerms: RelatedSearchTermsResults[];
}
const RelatedSearchTerms = ({
  relatedSearchTerms
}: Props) => <div className="related__wrap" data-sentry-component="RelatedSearchTerms" data-sentry-source-file="RelatedSearchTerms.tsx">
    <div className="related__searches related--alternate">
      <span>Related Search: </span>
      {relatedSearchTerms.map(item => <a href={item.relatedSearchTermUrl} className={`colcatRelatedLinks ${ct("overflow-visible")}`}>
          {item.relatedTerm}
        </a>)}
    </div>
  </div>;
export default RelatedSearchTerms;